// extracted by mini-css-extract-plugin
module.exports = {"container":"TeamTypeSelector_container__3E6SM","refining":"TeamTypeSelector_refining__24PMN","buttons":"TeamTypeSelector_buttons__3kOF9","button":"TeamTypeSelector_button__aejYs"};